import { render } from "./Panels.vue?vue&type=template&id=6db3db96"
import script from "./Panels.vue?vue&type=script&lang=js"
export * from "./Panels.vue?vue&type=script&lang=js"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__